import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "./Table.module.scss";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = ({ columns, rows = 11, height = 25 }) => {
  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div className={styles.skeleton} key={rowIdx}>
          {columns?.map((column, colIdx) => (
            <Skeleton
              key={colIdx}
              width={column.width ? column.width : 130}
              height={25}
              style={{ minWidth: 100, maxWidth: 200 }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
